export default {
  'component.tagSelect.expand': '展開',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.rightContent.org.unknown': '未知企業',
  'component.rightContent.menu.center': '個人中心',
  'component.rightContent.menu.settings': '個人設定',
  'component.rightContent.menu.currentOrg': '當前企業: {name}',
  'component.rightContent.menu.switchOrg': '切換企業',
  'component.rightContent.menu.systemManagement': '系統管理',
  'component.rightContent.menu.logout': '退出登入',
  'component.rightContent.theme.light': '切換為亮色主題',
  'component.rightContent.theme.dark': '切換為暗色主題',
  'component.switchOrganization.title': '切換企業',
  'component.switchOrganization.empty': '暫無可切換的企業',
  'component.switchOrganization.action.switch': '切換',
  'component.switchOrganization.message.fetchFailed': '取得企業清單失敗',
  'component.switchOrganization.message.success': '切換企業成功',
  'component.switchOrganization.message.failed': '切換企業失敗',
};
